var React = require('react');

function Twitter (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M22.444 2.983c-.814.382-1.5.395-2.228.017.94-.592.982-1.006 1.321-2.125a8.857 8.857 0 01-2.886 1.163c-.828-.93-2.01-1.512-3.316-1.512-2.51 0-4.544 2.143-4.544 4.783 0 .376.04.742.117 1.091-3.777-.199-7.125-2.104-9.366-4.999a4.964 4.964 0 00-.616 2.406c0 1.66.803 3.124 2.022 3.981A4.364 4.364 0 01.89 7.191v.06c0 2.317 1.566 4.25 3.645 4.69a4.34 4.34 0 01-2.053.082c.58 1.9 2.257 3.283 4.245 3.322C4.783 16.95 2.372 17.618 0 17.325a12.4 12.4 0 006.965 2.149c8.36 0 12.928-7.289 12.928-13.61 0-.208-.003-.412-.012-.619.887-.673 1.954-1.302 2.563-2.262"}));
}

Twitter.defaultProps = {"width":"23","height":"20"};

module.exports = Twitter;

Twitter.default = Twitter;
